import React, { useState } from 'react';
import axios from 'axios';
import { Box, TextField, IconButton, CircularProgress, Container, Grid } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CardComponent from './CardComponent';

const SearchComponent = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (query.trim() === '') return; // Evita búsquedas vacías
    setLoading(true);
    try {
      const response = await axios.post('https://vectorizecfrescribe.malecon.workers.dev/search', { 
        query,
        site: 'www.cubaconecta.com' // Añadir el campo site
      });
      const articles = response.data;
      setResults(articles);
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Container sx={{ p: 3, bgcolor: '#f5f5f5', borderRadius: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <TextField 
          fullWidth 
          variant="outlined" 
          placeholder="Search..." 
          value={query} 
          onChange={(e) => setQuery(e.target.value)} 
          onKeyPress={handleKeyPress}
          sx={{ bgcolor: 'white', borderRadius: 1 }}
          disabled={loading}
        />
        <IconButton onClick={handleSearch} sx={{ ml: 2 }} disabled={loading}>
          <SearchIcon />
        </IconButton>
      </Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {results.map((article) => (
            <Grid item xs={12} sm={6} md={4} key={article.nid}>
              <CardComponent article={article} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default SearchComponent;
